import { Footer } from "gui/footer/footer";
import { Header } from "shared/Header/Header";
import { NotFoundPage } from "pages/404";
import { PageHead } from "gui/head/head";
import { PageMain } from "gui/page/page";
import { SanityDocumentPage } from "lib/sanity/types";
import { SanitySections } from "gui/sanity/sections";

export interface SanityProps {
  sanity?: SanityDocumentPage;
  preview: boolean;
  timestamp: string;
}

export const SanityPage: React.FC<SanityProps> = (props) => {
  if (!props.sanity) {
    return <NotFoundPage />;
  }

  // Generic pages have a title, a slug, and a list of sections.
  // This component renders the basic page layout, and then iterates
  // through all the page sections, rendering their respective components.
  return (
    <>
      <PageHead title={props.sanity.title} preview={props.preview} />
      <Header />
      <PageMain size="md" triangle1>
        <SanitySections page={props.sanity} />
      </PageMain>
      <Footer timestamp={props.timestamp} />
    </>
  );
};
